import { Injectable, OnDestroy } from '@angular/core';
import { AnaBizApplicationListStoreModel } from '@common/interfaces/ana-biz-application-list/ana-biz-application-list-store-model';
import {
  AnaBizApplicationListStore,
  selectAnaBizApplicationListState,
  setAnaBizApplicationList,
  updateAnaBizApplicationList,
} from '@common/store';
import { Store, select } from '@ngrx/store';
import { Observable, Subscription, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AnaBizApplicationListStoreService implements OnDestroy {
  private _subscriptions: Subscription[] = [];
  private _anaBizApplicationListStoreModel$: Observable<AnaBizApplicationListStoreModel>;
  private _anaBizApplicationListStoreModel: AnaBizApplicationListStoreModel = {};
  public get anaBizApplicationListStoreModel(): AnaBizApplicationListStoreModel {
    return this._anaBizApplicationListStoreModel;
  }

  constructor(private _store: Store<AnaBizApplicationListStore>) {
    this._anaBizApplicationListStoreModel$ = this._store.pipe(
      select(selectAnaBizApplicationListState),
      map((state) => state.model || {})
    );
  }

  ngOnDestroy(): void {
    this._subscriptions
      .filter((subscription) => subscription != null)
      .forEach((subscription) => subscription.unsubscribe());
  }

  public getAnaBizApplicationListStoreModel$(): Observable<AnaBizApplicationListStoreModel> {
    return this._anaBizApplicationListStoreModel$;
  }

  public setAnaBizApplicationListStoreModel(model: AnaBizApplicationListStoreModel) {
    this._store.dispatch(setAnaBizApplicationList({ model }));
  }

  public updateAnaBizApplicationListStoreModel(model: AnaBizApplicationListStoreModel) {
    this._store.dispatch(
      updateAnaBizApplicationList({
        model: {
          ...this._anaBizApplicationListStoreModel,
          ...model,
        },
      })
    );
  }
}
